import axios from "axios";

export default {
  updateFinanciadorId({ commit }, id) {
    commit("setFinanciadorId", id);
  },
  updateFinanciadorNom({ commit }, nom) {
    commit("setFinanciadorNom", nom);
  },
  updateFinanciadorUsaGecros({ commit }, usaGecros) {
    commit("setFinanciadorUsaGecros", usaGecros);
  },
  async getFinanciadores() {
    try {
      const response = await axios.get(`api/financiadores/get-financiadores`);
      return response?.data;
    } catch (error) {
      console.error("Error fetching financiadores:", error);
    }
  },
  async postFinanciador(context, payload) {
    try {
      const response = await axios.post(
        "api/financiadores/save-financiador",
        payload
      );
      return response;
    } catch (error) {
      console.error("Error al guardar cambios financiador", error);
    }
  },
  async getFinanciadoresReportes(context, payload) {
    try {
      const response = await axios.get(
        `api/financiadores/reportes-config/${payload}`
      );
      return response?.data;
    } catch (error) {
      console.error("Error fetching financiadores:", error);
    }
  },
  async postFinanciadoresReportes(context, payload) {
    try {
      const response = await axios.post(
        "api/financiadores/reportes-config",
        payload
      );
      return response;
    } catch (error) {
      console.error("Error al guardar cambios financiador", error);
    }
  },
  async deleteFinanciador(context, payload) {
    try {
      const response = await axios.delete(
        `api/financiadores/delete-financiador/${payload}`
      );
      return response;
    } catch (error) {
      console.error("Error al eliminar financiador", error);
    }
  },
  async getValidations(_, payload) {
    try {
      return (await axios.get(`/api/financiadores/validations/${payload}`))
        ?.data;
    } catch (error) {
      console.error("Error al traer los datos del prestador", error);
    }
  },
  async getTiposDocMapeoView(_, financiadorId) {
    try {
      const response = await axios.get(
        `/api/financiadores/tipos-doc-mapeo-view?financiadorId=${financiadorId}`
      );
      return response?.data;
    } catch (error) {
      console.error("Error al traer el mapeo de tipos de documento", error);
    }
  },
  async saveTiposDocMapeo(_, { financiadorId, mappings }) {
    try {
      const response = await axios.post(
        `/api/financiadores/tipos-doc-mapeo?financiadorId=${financiadorId}`,
        mappings
      );
      return response;
    } catch (error) {
      console.error("Error al guardar el mapeo de tipos de documento", error);
      throw error;
    }
  },
  async enviarCredencialesPorFinanciador(context, payload) {
    try {
      const response = await axios.get(
        `api/enviadorCredenciales/enviar-credenciales-por-financiador/${payload}`
      );
      return response?.data;
    } catch (error) {
      console.error("Error al enviar credenciales por financiador", error);
      throw error;
    }
  },
  async enviarCredencialesPorUsuarios(context, payload) {
    try {
      const response = await axios.post(
        "api/enviadorCredenciales/enviar-credenciales-por-usuarios",
        payload
      );
      return response?.data;
    } catch (error) {
      console.error("Error al enviar credenciales por usuarios", error);
      throw error;
    }
  },
};
